import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const LogOutIcon = forwardRef<SVGSVGElement, IconProps>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M5 4a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h4a1 1 0 1 1 0 2H5a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3h4a1 1 0 0 1 0 2H5Z" />
    <path d="M15.3 6.3a1 1 0 0 1 1.4 0l5 5c.4.4.4 1 0 1.4l-5 5a1 1 0 0 1-1.4-1.4l3.3-3.3H8.9c-.5 0-.9-.4-.9-1s.4-1 1-1h9.6l-3.3-3.3a1 1 0 0 1 0-1.4Z" />
  </Icon>
));
export default LogOutIcon;
